module.exports = __webpack_public_path__ + "static/media/transferencia.b270c15c.svg";